"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _tooltip = _interopRequireDefault(require("../tooltip/tooltip"));

var _inputModule = _interopRequireDefault(require("./input.module.scss"));

var _excluded = ["className", "inputClassName", "labelClassName", "type", "value", "label", "maxLength", "disabled", "required", "error", "multiline", "rows", "onChange", "onFocus", "onBlur", "place", "hideLabel", "placeholder"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function targetIsDescendant(event, parent) {
  var node = event.target;

  while (node !== null) {
    if (node === parent) return true;
    node = node.parentNode;
  }

  return false;
}

var Input = /*#__PURE__*/_react["default"].forwardRef(function (_ref, ref) {
  var _cx3;

  var className = _ref.className,
      inputClassName = _ref.inputClassName,
      labelClassName = _ref.labelClassName,
      type = _ref.type,
      value = _ref.value,
      label = _ref.label,
      maxLength = _ref.maxLength,
      disabled = _ref.disabled,
      required = _ref.required,
      error = _ref.error,
      multiline = _ref.multiline,
      rows = _ref.rows,
      onChange = _ref.onChange,
      onFocus = _ref.onFocus,
      onBlur = _ref.onBlur,
      place = _ref.place,
      hideLabel = _ref.hideLabel,
      placeholder = _ref.placeholder,
      other = _objectWithoutProperties(_ref, _excluded);

  var inputRef = (0, _react.useRef)(null);

  var _useState = (0, _react.useState)({
    x: null,
    y: null,
    height: null,
    width: null
  }),
      _useState2 = _slicedToArray(_useState, 2),
      anchor = _useState2[0],
      setAnchor = _useState2[1];

  var _useState3 = (0, _react.useState)(''),
      _useState4 = _slicedToArray(_useState3, 2),
      toolTipKey = _useState4[0],
      setToolTipKey = _useState4[1];

  var length = maxLength && value ? value.length : 0;

  var _useState5 = (0, _react.useState)(!!error),
      _useState6 = _slicedToArray(_useState5, 2),
      isErrorVisible = _useState6[0],
      setIsErrorVisible = _useState6[1];

  var positionError = (0, _react.useCallback)(function () {
    if (error && inputRef.current) {
      var _inputRef$current$get = inputRef.current.getBoundingClientRect(),
          y = _inputRef$current$get.y,
          height = _inputRef$current$get.height;

      var viewportHeight = window.innerHeight - 60;
      var offsetFromTop = y - height;
      var offsetFromBottom = viewportHeight - (y + height);

      if (offsetFromTop > 0 && offsetFromBottom > 0) {
        // Error is within the viewport, no need to adjust
        var _inputRef$current$get2 = inputRef.current.getBoundingClientRect(),
            top = _inputRef$current$get2.top,
            left = _inputRef$current$get2.left,
            _height = _inputRef$current$get2.height,
            width = _inputRef$current$get2.width;

        var _window = window,
            scrollY = _window.scrollY,
            scrollX = _window.scrollX;
        setAnchor({
          height: _height,
          width: width,
          y: top + scrollY,
          x: left + scrollX
        });
        setToolTipKey("".concat(inputRef.current.offsetTop, " - ").concat(inputRef.current.offsetLeft, "- ").concat(inputRef.current.offsetWidth));
      } else {
        // Error is outside the viewport - Set visibility as false
        setIsErrorVisible(false);
      }
    }
  }, [error]);

  var showError = function showError() {
    if (error) {
      setIsErrorVisible(true);
      positionError();
    }
  };

  var handleChange = function handleChange(event) {
    if (!disabled) {
      var changedValue = event.target.value;

      if (maxLength && changedValue.length > maxLength) {
        changedValue = changedValue.substring(0, maxLength);
      }

      onChange(changedValue, event);
    }
  };

  (0, _react.useEffect)(function () {
    if (error) {
      setIsErrorVisible(true);
      positionError();
    } else {
      setIsErrorVisible(false);
    }
  }, [error, positionError]);
  (0, _react.useEffect)(function () {
    var clickListener = function clickListener(event) {
      if (!targetIsDescendant(event, inputRef.current)) {
        setIsErrorVisible(false);
      }
    };

    window.addEventListener('click', clickListener);
    return function () {
      window.removeEventListener('click', clickListener);
    };
  }, []);
  (0, _react.useEffect)(function () {
    var isScrolling;

    var scrollListener = function scrollListener() {
      setIsErrorVisible(false); // Clear our timeout throughout the scroll

      clearTimeout(isScrolling); // Set a timeout to run after scrolling ends

      isScrolling = setTimeout(function () {
        setIsErrorVisible(!!error);
        positionError();
      }, 200);
    };

    if (error) {
      document.addEventListener('scroll', scrollListener, true);
    }

    return function () {
      document.removeEventListener('scroll', scrollListener, true);
      clearTimeout(isScrolling);
    };
  }, [error, positionError]); // create element props for input or textarea

  var elementProps = _objectSpread(_objectSpread({
    ref: ref
  }, other), {}, {
    className: (0, _classnames["default"])(_inputModule["default"].inputElement, _defineProperty({}, _inputModule["default"].filled, value || placeholder), inputClassName),
    type: type,
    required: required,
    disabled: disabled,
    value: value,
    placeholder: placeholder,
    onChange: handleChange,
    onFocus: onFocus,
    onBlur: onBlur
  });

  if (multiline) {
    elementProps.rows = rows;
    elementProps.className = (0, _classnames["default"])(_inputModule["default"].inputElement, _defineProperty({}, _inputModule["default"].filled, value || placeholder), _inputModule["default"].textArea, inputClassName);
  }

  return /*#__PURE__*/_react["default"].createElement("div", {
    ref: inputRef,
    onClick: function onClick() {
      showError();
    },
    onFocus: function onFocus() {
      showError();
    },
    onBlur: function onBlur() {
      setIsErrorVisible(false);
    },
    className: (0, _classnames["default"])(_inputModule["default"].input, (_cx3 = {}, _defineProperty(_cx3, _inputModule["default"].hasError, !!error), _defineProperty(_cx3, _inputModule["default"].inputTextArea, multiline), _cx3), className)
  }, /*#__PURE__*/_react["default"].createElement("label", null, /*#__PURE__*/_react["default"].createElement(multiline ? 'textarea' : 'input', elementProps), label ? /*#__PURE__*/_react["default"].createElement("span", {
    className: (0, _classnames["default"])(_inputModule["default"].label, labelClassName, {
      'sr-only': hideLabel
    })
  }, label) : null), /*#__PURE__*/_react["default"].createElement(_tooltip["default"], {
    key: toolTipKey,
    place: place,
    show: isErrorVisible,
    anchor: anchor
  }, error), maxLength && /*#__PURE__*/_react["default"].createElement("span", {
    className: _inputModule["default"].counter
  }, "".concat(length, "/").concat(maxLength)));
});

Input.displayName = 'Input';
Input.propTypes = {
  className: _propTypes["default"].string,
  inputClassName: _propTypes["default"].string,
  labelClassName: _propTypes["default"].string,
  type: _propTypes["default"].string,
  value: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
  label: _propTypes["default"].node,
  error: _propTypes["default"].node,
  maxLength: _propTypes["default"].number,
  multiline: _propTypes["default"].bool,
  rows: _propTypes["default"].number,
  disabled: _propTypes["default"].bool,
  required: _propTypes["default"].bool,
  onChange: _propTypes["default"].func,
  onFocus: _propTypes["default"].func,
  onBlur: _propTypes["default"].func,
  place: _propTypes["default"].string,
  hideLabel: _propTypes["default"].bool,
  placeholder: _propTypes["default"].string
};

var noop = function noop() {};

Input.defaultProps = {
  className: '',
  inputClassName: '',
  labelClassName: ',',
  type: 'text',
  value: '',
  label: '',
  error: '',
  maxLength: null,
  multiline: false,
  rows: 1,
  disabled: false,
  required: false,
  onChange: noop,
  onFocus: noop,
  onBlur: noop,
  place: 'right',
  hideLabel: false,
  placeholder: null
};
var _default = Input;
exports["default"] = _default;